import React from "react";
import tw, { styled } from "twin.macro";
import { graphql, useStaticQuery } from "gatsby";

import { FaTwitter, FaFacebookF, FaLinkedin, FaYoutube } from "react-icons/fa";

const Container = styled.div`
  ${tw`flex flex-row text-2xl`}
`;
const socials = (platform) => {
  switch (platform) {
    case "FA":
      return <FaFacebookF />;
    case "TW":
      return <FaTwitter />;
    case "YT":
      return <FaYoutube />;
    case "LI":
      return <FaLinkedin />;
  }
};
const SocialMedia = () => {
  const { accounts } = useStaticQuery(graphql`
    {
      wp {
        acfOptionsFooter {
          footer {
            accounts: socialMedia {
              ariaLabel
              platform
              url
            }
          }
        }
      }
    }
  `).wp.acfOptionsFooter.footer;
  return (
    <Container>
      {accounts.map(({ url, platform, ariaLabel }, i) => {
        return (
          <a
            tw="hover:text-primary duration-500 ease-in-out px-1.5"
            key={i}
            href={url}
            aria-label={ariaLabel}
            target="_blank"
          >
            {socials(platform)}
          </a>
        );
      })}
    </Container>
  );
};

export default SocialMedia;
